import { ROUTE_CREDENTIALS, ROUTE_REDESIGN } from 'js/constants/pathnames';
import has from 'lodash/has';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { connect } from 'react-redux';
import {
  loadDataCredentialListing,
  loadVendorAuths,
  setContextualSupport,
  unsetContextualSupport,
} from 'js/actions';
import { GET_CREDENTIALS_REQUEST, GET_CREDENTIAL_REQUEST } from 'js/constants/actionTypes';
import { SearchFilterViews } from 'js/constants/visibilityFilters';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import UIUtils from '../../lib/UIUtils';
import { getEligibleCredentialEntities } from 'js/reducers/entities';
import { EXTERNAL_INTEGRATIONS } from 'js/constants/externalIntegrations';

import ViewCredentials from './ViewCredentials';

function excludeCredentialsByCredentialType(credentials = [], types = []) {
  return credentials.filter(
    (credential) =>
      'credentials_type' in credential && !types.includes(credential.credentials_type),
  );
}

const mapStateToProps = (state, ownProps) => {
  const {
    app: {
      listing: { aclQueryMode, selectedCardId },
      visibilityFilters: { filters },
    },
    request,
  } = state;
  const credentialId = UIUtils.extractParamFromURL(ownProps.match) || selectedCardId;

  const getSourceMeta = (credentialId) => {
    const {
      entities: { credentials, vendors },
      paging: { metaInfoById },
    } = state;

    const connectionOrVendorType = getConnectionOrVendorType(
      credentials[credentialId],
      vendors,
      'credentials_type',
      'vendor_id',
    );

    if (connectionOrVendorType && metaInfoById && has(metaInfoById, connectionOrVendorType)) {
      return metaInfoById[connectionOrVendorType];
    }

    return null;
  };

  /**
   * Don't list external integrations credential
   */
  const filteredCredentials = excludeCredentialsByCredentialType(
    getEligibleCredentialEntities(state),
    Object.values(EXTERNAL_INTEGRATIONS).map((integration) => integration.credential.type),
  );

  return {
    credentialId,
    credentials: filteredCredentials,
    getSourceMeta,
    aclQueryMode,
    filters: filters[SearchFilterViews.CREDENTIALS],
    isLoading:
      !!request[GET_CREDENTIALS_REQUEST] ||
      (request[GET_CREDENTIAL_REQUEST] && !ownProps.onlyTableView),
  };
};

const ViewCredentialsContainer = connect(mapStateToProps, {
  loadDataCredentialListing,
  loadVendorAuths,
  setContextualSupport,
  unsetContextualSupport,
})(ViewCredentials);

ViewCredentialsContainer.screenConfig = {
  screenName: 'ViewCredentialsContainer',
  domain: 'integrate',
  path: [
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_CREDENTIALS}/new`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_CREDENTIALS}/:id/edit`,
    `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_CREDENTIALS}`,
  ],
  exact: true,
  pageTitle: 'Credentials',
  defaultProps: {
    withHeader: false,
    onlyTableView: true,
  },
};

export default ViewCredentialsContainer;
